import { ReactNode } from 'react'

export enum DrawerState {
  OPEN = 'OPEN',
  CLOSING = 'CLOSING',
  CLOSED = 'CLOSED',
}

export type ExpandableDrawerProps = {
  classPrefix: string
  children: ReactNode
  scrollable?: boolean
  drawerName?: string
  drawerIconUrl?: string
  hasCloseButton: boolean
  state: DrawerState
  onOpenChange: (open: boolean) => void
  onOpenAutoFocus?: (event: Event) => void
}
